import { render, staticRenderFns } from "./SbolDetail.vue?vue&type=template&id=48959c3e&scoped=true&"
import script from "./SbolDetail.vue?vue&type=script&lang=js&"
export * from "./SbolDetail.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolDetail.vue?vue&type=style&index=0&id=48959c3e&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "48959c3e",
  null
  ,true
)

export default component.exports